var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "175",
      "height": "175"
    }
  }, _vm.$listeners), [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#005149",
      "d": "M73.926 130.325c1.98-7.033 7.013-24.084 10.61-36.162a.748.748 0 0 0-.708-.963c-6.97-.108-17.938-.377-20.945-.689C65.7 86.805 86.026 51.688 88.35 48.566h18.387c-2.528 4.137-13.352 20.121-20.776 30.972a.752.752 0 0 0 .584 1.173c.77.037 17.33.822 22.86.962-4.074 6.153-28.11 39.078-35.478 48.653m36.764-50.132c-2.867 0-18.092-.701-22.733-.918C109.107 48.35 108.92 48 108.641 47.471a.77.77 0 0 0-.673-.406H88.01c-.496.01-.585.013-2.92 3.819-3.452 5.62-9.748 16.438-14.458 24.665-9.805 17.124-9.69 17.362-9.46 17.837q.015.034.034.066c.27.44.547.895 21.611 1.231-11.506 38.65-11.389 38.807-11.078 39.22a.76.76 0 0 0 .602.302h.01c.493-.007.72-.01 16.553-21.514 7.292-9.903 17.143-23.422 20.911-28.936 1.763-2.58 1.732-2.665 1.578-3.075a.75.75 0 0 0-.702-.488"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFE86C",
      "d": "M87.209 20.504c.983 0 1.784-.8 1.784-1.784V1.785c0-.984-.801-1.784-1.784-1.784-.984 0-1.784.8-1.784 1.784V18.72c0 .984.8 1.784 1.784 1.784M18.72 85.425H1.783c-.984 0-1.784.8-1.784 1.784s.8 1.784 1.784 1.784H18.72c.984 0 1.784-.8 1.784-1.784s-.8-1.784-1.784-1.784m68.489 68.488c-.984 0-1.784.8-1.784 1.784v16.935c0 .984.8 1.784 1.784 1.784.983 0 1.784-.8 1.784-1.784v-16.935c0-.984-.801-1.784-1.784-1.784m85.423-68.488h-16.935c-.984 0-1.784.8-1.784 1.784s.8 1.784 1.784 1.784h16.935c.984 0 1.784-.8 1.784-1.784s-.8-1.784-1.784-1.784M27.196 24.71h-.001a1.75 1.75 0 0 0-1.243-.515c-.47 0-.911.183-1.243.514a1.76 1.76 0 0 0 0 2.486l12.789 12.841c.346.347.806.54 1.297.54a1.74 1.74 0 0 0 1.229-.53 1.785 1.785 0 0 0 .024-2.536z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFE86C",
      "d": "m27.196 24.71 12.852 12.8a1.785 1.785 0 0 1-.024 2.537 1.74 1.74 0 0 1-1.23.53 1.82 1.82 0 0 1-1.296-.54l-12.79-12.842a1.76 1.76 0 0 1 1.244-3c.469 0 .91.183 1.243.514v.002m10.303 109.67-12.788 12.84a1.69 1.69 0 0 0-.095 2.393l.078.08c.349.372.77.58 1.248.555.47-.002.92-.196 1.243-.53l12.853-12.799c.337-.339.524-.789.524-1.269s-.187-.93-.526-1.269c-.677-.678-1.86-.678-2.537 0m112.23 12.86L136.92 134.38a1.79 1.79 0 0 0-1.27-.524c-.478 0-.93.185-1.268.525a1.8 1.8 0 0 0 0 2.538l12.839 12.788c.335.346.785.538 1.25.542a1.6 1.6 0 0 0 1.216-.52c.368-.347.556-.763.57-1.212a1.67 1.67 0 0 0-.454-1.202l-.075-.075zM135.627 40.577a1.82 1.82 0 0 0 1.293-.541l12.788-12.84c.333-.333.516-.774.516-1.244s-.183-.91-.515-1.242a1.75 1.75 0 0 0-1.243-.515c-.47 0-.911.183-1.243.515L134.38 37.498a1.79 1.79 0 0 0-.011 2.525c.344.357.794.55 1.257.554"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }